// extracted by mini-css-extract-plugin
export default {"calculator":"Calculator_calculator__14g6f"};